import {Controller} from "@hotwired/stimulus"
import CameraController from "./camera_controller";

// Connects to data-controller="cctv--vcl-plugin-camera"
export default class extends CameraController {
  static values = {
    rtspUrl: String,
    name: String,
    id: String,
  }

  connect() {
  }

  async buildCameraBlock(camerasContainer, info = null) {
    this.container = document.createElement("div");
    this.containerBuild(this.container, this.idValue)

    let wrapper = document.createElement('div');

    this.playerElement = document.createElement("div");
    this.playerBuild(this.playerElement, this.idValue)

    this.vclPlayerBuild(this.playerElement, this.idValue)

    this.infoElement = document.createElement("div");

    this.headerElement = document.createElement("div");
    this.headerBuild(this.headerElement, this.nameValue)

    this.container.appendChild(this.headerElement);
    this.container.appendChild(this.infoElement);
    this.container.appendChild(wrapper);

    wrapper.appendChild(this.playerElement);
    camerasContainer.appendChild(this.container);

  }

}
